import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import AuthContext from "../../context/auth/AuthContext";
import { Button, Icon } from "../design";

/** Billing tab of "Manage workspace": who invoices go to, link to invoices. */
const BillingCustomization = ({ onClose, onEditBilling }) => {
  const { _t } = useTranslator();
  const { workspaceId } = useParams();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const saved = user?.current_workspace?.billing_details ?? {};
  const billingDetails = [
    saved.company_name,
    saved.full_name,
    saved.tax_id,
    saved.country,
    saved.city,
    saved.address,
    saved.postal_code,
  ]
    .filter((item) => item && item.toString().trim() !== "")
    .join(", ");

  return (
    <div className="workspace-tab-panel">
      <h3 className="workspace-section-title">{_t("paymentDetails")}</h3>
      <div className="workspace-billing-row">
        <div className="workspace-billing-row__text">
          <span className="workspace-billing-row__label">{_t("billedTo")}</span>
          <span className="workspace-billing-row__value">
            {billingDetails || _t("dataNotAvailable")}
          </span>
        </div>
        <Button
          variant="secondary"
          iconStart={<Icon name="edit" size={16} />}
          onClick={onEditBilling}
        >
          {_t("editInformation")}
        </Button>
      </div>

      <h3 className="workspace-section-title">{_t("invoices")}</h3>
      <div className="workspace-billing-row">
        <p className="workspace-billing-row__value">
          {_t("billingDetailsDescription")}
        </p>
        <Button
          variant="secondary"
          iconEnd={<Icon name="arrowRight" size={16} />}
          onClick={() => {
            onClose();
            navigate(`/${workspaceId}/credits-ledger`);
          }}
        >
          {_t("viewAllInvoices")}
        </Button>
      </div>
    </div>
  );
};

export default BillingCustomization;
